(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 749px)');

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function tryPlay(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function loopVideo(video) {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    tryPlay(video);
  }

  // Phones and reduced-motion: play the clip as a plain muted loop, started
  // when it actually scrolls into view. iOS only grants muted autoplay to a
  // visible video, so the old fire-once-at-DOMContentLoaded call was rejected
  // for anything below the fold and — with its rejection swallowed and never
  // retried — left the video frozen on frame one for the rest of the session.
  function playInView(video) {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;

    if (!('IntersectionObserver' in window)) {
      tryPlay(video);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        each(entries, function (entry) {
          if (entry.isIntersecting) tryPlay(video);
          else if (!video.paused) video.pause();
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(video);

    // Belt and braces: some iOS configurations (Low Power Mode above all)
    // refuse autoplay outright until the visitor has interacted with the page.
    var retry = function () {
      if (video.paused) tryPlay(video);
      if (!video.paused) {
        document.removeEventListener('touchstart', retry);
        document.removeEventListener('click', retry);
      }
    };
    document.addEventListener('touchstart', retry, { passive: true });
    document.addEventListener('click', retry);
  }

  // The brand tiles used to be revealed row by row off the scrub's progress
  // value. With the pin container collapsed on phones there is no progress to
  // read — and the mobile design is deliberately static — so they are simply
  // shown, no observer and no stagger.
  function revealAll(container) {
    each(container.querySelectorAll('a'), function (tile) {
      tile.classList.add('is-revealed');
    });
  }

  function init() {
    var videos = document.querySelectorAll('video[data-scroll-scrub]');
    if (!videos.length) return;

    // A video the mobile design replaces with a still (the section CSS hides
    // the <video> and shows a poster <img> instead). Never start it on a
    // phone: play() on a display:none video still pulls the whole file down,
    // and these clips are 8-10MB each.
    function stillOnMobile(video) {
      return video.hasAttribute('data-mobile-still');
    }

    // Those clips ship their <source> as data-src so the browser has nothing
    // to fetch until we say so. Anything wider than a phone gets the real src
    // attached here, before the scrub or the loop asks the video to do
    // anything.
    function attachSource(video) {
      var sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      each(sources, function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });
      video.load();
    }

    if (!phone.matches) each(videos, attachSource);

    // A desktop window that starts narrow and is widened later would otherwise
    // be stuck on the poster for the rest of the session.
    if (phone.addEventListener) {
      phone.addEventListener('change', function (e) {
        if (!e.matches) each(videos, attachSource);
      });
    }

    if (reduced.matches) {
      each(videos, function (video) {
        if (!stillOnMobile(video) || !phone.matches) loopVideo(video);
      });
      each(document.querySelectorAll('[data-scrub-brands]'), revealAll);
      return;
    }

    // iOS Safari cannot seek a standard MP4 frame-accurately, so scrubbing
    // currentTime against scroll shows one frozen frame. Phones get the loop
    // treatment and the section CSS collapses the tall pin containers to
    // normal height; the scroll loop below never starts.
    if (phone.matches) {
      // Clear anything a desktop-width scrub wrote before the viewport crossed
      // the breakpoint, so nothing is left part-faded or offset.
      each(
        document.querySelectorAll('.exploded-machine__text, [data-scrub-features], [data-scrub-whiteout]'),
        function (el) {
          el.style.removeProperty('opacity');
          el.style.removeProperty('transform');
        }
      );
      each(videos, function (video) {
        if (stillOnMobile(video)) {
          // Its <source> is still parked on data-src, so there is nothing to
          // play and nothing to fetch. Just make sure autoplay cannot fire.
          video.removeAttribute('autoplay');
          video.preload = 'none';
          return;
        }
        playInView(video);
      });
      each(document.querySelectorAll('[data-scrub-brands]'), revealAll);
      return;
    }

    var items = [];

    each(videos, function (video) {
      video.muted = true;
      // The markup ships preload="metadata" for phones' sake; seeking smoothly
      // needs the whole file, so ask for it here.
      video.preload = 'auto';
      video.load();
      video.pause();
      var item = {
        video: video,
        mode: video.getAttribute('data-scroll-scrub'),
        duration: 0,
        target: 0,
        current: 0,
      };
      var setDuration = function () {
        if (video.duration && isFinite(video.duration)) item.duration = video.duration;
      };
      if (video.readyState >= 1) setDuration();
      video.addEventListener('loadedmetadata', setDuration);
      items.push(item);
    });

    function progress(item) {
      var el = item.video.closest('[data-scrub-frame]') || item.video;
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight;
      var p;
      if (item.mode === 'hero' || item.mode === 'pin') {
        var travel = rect.height - vh;
        if (travel <= 0) travel = rect.height * 0.85;
        p = -rect.top / travel;
      } else {
        p = (vh - rect.top) / (vh + rect.height);
      }
      return Math.min(Math.max(p, 0), 1);
    }

    function tick() {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var p = progress(item);
        if (item.duration) {
          var videoP = p;
          if (item.mode === 'hero') videoP = Math.min(p / 0.7, 1);
          // With no logo wall to reveal at the end, the clip gets the whole pin.
          if (item.mode === 'pin') videoP = Math.min(p / (item.brands === null ? 0.9 : 0.6), 1);
          item.target = videoP * (item.duration - 0.05);
          item.current += (item.target - item.current) * 0.14;
          if (Math.abs(item.current - item.target) > 0.008 && item.video.readyState >= 2) {
            try {
              item.video.currentTime = item.current;
            } catch (e) {}
          }
        }
        if (item.mode === 'hero') {
          if (item.whiteout === undefined) {
            var frame = item.video.closest('[data-scrub-frame]');
            item.whiteout = frame ? frame.querySelector('[data-scrub-whiteout]') : null;
            item.features = frame ? frame.querySelector('[data-scrub-features]') : null;
          }
          if (item.whiteout) {
            var fade = Math.min(Math.max((p - 0.62) / 0.16, 0), 1);
            item.whiteout.style.opacity = fade;
          }
          if (item.features) {
            var reveal = Math.min(Math.max((p - 0.8) / 0.15, 0), 1);
            item.features.style.opacity = reveal;
            item.features.style.transform = 'translateY(' + 3 * (1 - reveal) + 'rem)';
            item.features.classList.toggle('is-active', reveal > 0.6);
          }
        }
        if (item.mode === 'pin') {
          if (item.brands === undefined) {
            var pinFrame = item.video.closest('[data-scrub-frame]');
            item.brands = pinFrame ? pinFrame.querySelector('[data-scrub-brands]') : null;
            item.pinText = pinFrame ? pinFrame.querySelector('.exploded-machine__text') : null;
            item.rows = [];
            if (item.brands) {
              var tiles = item.brands.querySelectorAll('a');
              var rowMap = {};
              each(tiles, function (tile) {
                var key = Math.round(tile.offsetTop / 10);
                (rowMap[key] = rowMap[key] || []).push(tile);
              });
              Object.keys(rowMap)
                .sort(function (a, b) {
                  return a - b;
                })
                .forEach(function (key) {
                  item.rows.push(rowMap[key]);
                });
            }
          }
          if (item.pinText && item.brands) {
            var textFade = Math.min(Math.max(1 - (p - 0.58) / 0.1, 0), 1);
            item.pinText.style.opacity = textFade;
            item.pinText.style.pointerEvents = textFade < 0.1 ? 'none' : '';
          }
          if (item.rows && item.rows.length) {
            var start = 0.66;
            var span = 0.32;
            for (var r = 0; r < item.rows.length; r++) {
              var threshold = start + (span * r) / item.rows.length;
              var on = p >= threshold;
              for (var t = 0; t < item.rows[r].length; t++) {
                item.rows[r][t].classList.toggle('is-revealed', on);
              }
            }
          }
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
